// MARK: - Table of Contents
// 1. Watch Trend Workflow Status
// 2. Watch Trend Message Contract

// MARK: - Watch Trend Workflow Status

export const watchTrendWorkflowStatuses = Object.freeze([
  Object.freeze({ value: "completed", label: "New Report" }),
  Object.freeze({ value: "inReview", label: "In Review" }),
  Object.freeze({ value: "monitoring", label: "Monitoring" }),
  Object.freeze({ value: "patternIdentified", label: "Pattern Identified" }),
  Object.freeze({ value: "escalated", label: "Legal Review" }),
  Object.freeze({ value: "closed", label: "Closed" })
]);

export const watchTrendWorkflowStatusValues = Object.freeze(
  watchTrendWorkflowStatuses.map(status => status.value)
);

export const watchTrendWorkflowStatusLabel = value =>
  watchTrendWorkflowStatuses.find(status => status.value === value)?.label ??
  "New Report";

// MARK: - Watch Trend Message Contract

export const watchTrendMessageVisibilities = Object.freeze([
  "internal",
  "client"
]);

export const watchTrendMessageSenderRoles = Object.freeze([
  "firm",
  "client",
  "system"
]);

export const watchTrendMessageDeliveryStatuses = Object.freeze([
  "saved",
  "queued",
  "delivered",
  "failed",
  "read"
]);
